export default [
    {
        path: '/objectif_repport',
        name: 'objectif-repport',
        meta: { requiresAuth: true,
            requiresAdminOrSuperAdmin: true,},  // Nécessite un rôle "Admin"
        component: () => import('@/views/rapport/ReportObjectifView.vue'),

      }, 
      {
        path: '/evaluation_repport',
        name: 'evaluation-repport',
        meta: { requiresAuth: true,
            requiresAdminOrSuperAdmin: true,},  // Nécessite un rôle "Admin"
        component: () => import('@/views/rapport/ReportEvaluationView.vue'),
   
      },
    
]